<template>
    <div class="entry-content">
        <h2>Information</h2>
        <form @submit.prevent="handleFormSubmit">
            <input type="text" v-model="name" placeholder="Course Name" maxlength="400" required>
            <textarea name="description" id="descr" cols="10" rows="17" placeholder="Course Description" maxlength="400" v-model="description" required/>
            <div class="form-footer-wrapper">
                <div class="left-wrapper">
                    <button type="button" class="cancel delete" @click.prevent="handleDelete">Delete Course</button>
                </div>
                <div class="right-wrapper">
                    <button type="button" class="cancel" @click.prevent="handleRedirect">Cancel</button>
                    <input type="submit" class="save" value="Save" />
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import CheckApi from '@/api';

export default {
    props: [],
    name: 'AddCourse',
    components: {},
    data() {
		return {
            name: '',
            description: ''
        }
    },
    mounted() {
        this.fetchCourseTemplate()
    },
    methods: {
        async fetchCourseTemplate() {
            const response = await CheckApi.getCourseTemplateById(this.$route.params.courseTemplateId)
            const {
                name,
                description
            } = response.data.data
            this.name = name
            this.description = description
        },
        async handleFormSubmit() {
            await CheckApi.updateCourseTemplateById({name: this.name, description: this.description, courseTemplateId: this.$route.params.courseTemplateId})
            this.$router.push('/templates?page=1')
        },
        handleRedirect() {
            this.$router.push('/templates?page=1')
        },
        async handleDelete() {
            await CheckApi.handleCourseTemplateDelete(this.$route.params.courseTemplateId)
            this.handleRedirect()
        }
    }
}
</script>

<style lang="scss" scoped>

    .form-footer-wrapper {
        display: flex;
        justify-content: space-between;

        .right-wrapper {
            display: flex;
        }
    }

    .cancel {
        background-color: transparent;
        border: .0625em solid #141638;

        &.delete {
            background-color: #ff8900;
            width: 150px !important;
            color: white;
            border: none;

            &:hover {
                color: white;
            }
        }

        &:hover {
            color: #141638;
        }
    }

    .cancel,
    .save {
        width: 100px !important;
        height: 30px !important;
        border-radius: .75em !important;
        text-align: center !important;
        cursor: pointer;
    }

    .save {
        margin-left: 15px;
        background-color: #08ce97;
        border-style: none;
        color: #fff;
        border-radius: 0.75em;
        display: block !important;
        margin: 0 !important;
        margin-left: 15px !important;
        padding: 5px;
    }
</style>